module.exports = __webpack_public_path__ + "img/site-signin-background-1200.3aff8172.webp";